export default function WizardSteps({ steps, currentStep, completedSteps, onStepClick }) {
    const isReachable = (stepNumber) => stepNumber <= currentStep || completedSteps.includes(stepNumber - 1);

    return (
        <div className="wizard-steps">
            {steps.map((step) => {
                const isCompleted = completedSteps.includes(step.number);
                const isActive = currentStep === step.number;
                const reachable = isReachable(step.number);

                return (
                    <button
                        key={step.number}
                        type="button"
                        className={`wizard-step-chip${isActive ? " active" : ""}${isCompleted ? " completed" : ""}`}
                        disabled={!reachable}
                        onClick={() => reachable && onStepClick(step.number)}
                    >
                        {isCompleted ? <i className="fa fa-check" /> : <span className="step-number">{step.number}.</span>}
                        <span>{step.label}</span>
                    </button>
                );
            })}
        </div>
    );
}
